import Vue from 'vue';
import Router from 'vue-router';
import Contest from '@/views/Contest.vue';
import ContestQuestion from '@/views/ContestQuestion.vue';
import ContestPersonal from '@/views/ContestPersonal.vue';
import ContestLegals from '@/views/ContestLegals.vue';
import ContestEnd from '@/views/ContestEnd.vue';
import ContestError from '@/views/ContestError.vue';
import ContestWinners from '@/views/ContestWinners.vue';

Vue.use(Router);

export default new Router({
  // scrollBehavior: () => ({
  //   x: 0,
  //   y: 0,
  // }),
  routes: [
    {
      path: '/contest',
      component: Contest,
      children: [
        {
          path: '',
          redirect: 'winners',
        },
        {
          path: 'winners',
          name: 'contest winners',
          component: ContestWinners,
        },
        // {
        //   path: 'question',
        //   name: 'contest question',
        //   component: ContestQuestion,
        // },
        // {
        //   path: 'personal',
        //   name: 'contest personal',
        //   component: ContestPersonal,
        // },
        // {
        //   path: 'legals',
        //   name: 'contest legals',
        //   component: ContestLegals,
        // },
        // {
        //   path: 'end',
        //   name: 'contest end',
        //   component: ContestEnd,
        // },
        // {
        //   path: 'error',
        //   name: 'contest error',
        //   component: ContestError,
        //   props: route => ({ backButtonTo: route.query.to }),
        // },
      ],
    },
    {
      path: '*',
      redirect: '/contest',
    },
  ],
});
